module.exports = "/assets/images/logo_5944bf.svg";